export const SIGNUP_PATH = '/signup'
export const CARE_EMAIL = 'ads-help@instacart.com'
export const BLOG_URL = 'https://www.instacart.com/company/instacart-ads/'
